export enum TextStyle {
  DEFAULT,
  HIGHLIGHTED,
}
